export default __webpack_public_path__ + "static/media/products2.0a08e49b.png";